/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The SignInPayload model module.
 * @module model/SignInPayload
 * @version v1
 */
export class SignInPayload {
  /**
   * Constructs a new <code>SignInPayload</code>.
   * @alias module:model/SignInPayload
   * @class
   * @param login {String} 
   * @param password {String} 
   */
  constructor(login, password) {
    this.login = login;
    this.password = password;
  }

  /**
   * Constructs a <code>SignInPayload</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SignInPayload} obj Optional instance to populate.
   * @return {module:model/SignInPayload} The populated <code>SignInPayload</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SignInPayload();
      if (data.hasOwnProperty('login'))
        obj.login = ApiClient.convertToType(data['login'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} login
 */
SignInPayload.prototype.login = undefined;

/**
 * @member {String} password
 */
SignInPayload.prototype.password = undefined;

